import { ENDPOINTS } from "@constants";
import AbstractService from "./AbstractService";

export default class AssignmentRulesService extends AbstractService {
	static endpoint = ENDPOINTS.assignmentGroups;

	static getAll() {
		return this.get({
			endpoint: this.endpoint,
		});
	}

	static getAllDetails() {
		return this.get({
			endpoint: `${this.endpoint}/GetAssignmentGroupDetailedList`,
		});
	}

	static getStaggeredRules() {
		return this.get({
			endpoint: "StaggeredAssignmentRule/GetStaggeredAssignmentRuleList",
		});
	}

	static getStaggeredRule(id) {
		return this.get({
			endpoint: `StaggeredAssignmentRule/Get/${id}`,
		});
	}

	static createStaggeredRule(data) {
		return this.post({
			endpoint: "StaggeredAssignmentRule/AddStaggeredAssignmentRule",
			data,
		});
	}

	static updateStaggeredRule(queryParams, data) {
		return this.put({
			endpoint: "StaggeredAssignmentRule/UpdateStaggeredAssignmentRule",
			queryParams,
			data,
		});
	}

	static deleteStaggeredRule(id) {
		return this.del({
			endpoint: `StaggeredAssignmentRule/Delete/${id}`,
		});
	}

	static getById(id) {
		return this.get({
			endpoint: `${this.endpoint}/${id}`,
		});
	}

	static create(queryParams, data) {
		return this.post({
			endpoint: this.endpoint,
			queryParams,
			data,
		});
	}

	static update(queryParams, data) {
		return this.put({
			endpoint: this.endpoint,
			queryParams,
			data,
		});
	}

	static delete(id) {
		return this.del({
			endpoint: `${this.endpoint}/${id}`,
		});
	}
}
